import React from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import CustomImg from "../Assets/img/custom-design.webp";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Je_welryspelling } from "../../../../Helpers/request";
import CustomVideo from '../../../../Assets/custom-output-cut.mp4'

const CustomDesign = () => {
  return (
    <section className="custom-design section-space">
      <Container fluid className="showcase-container">
        <Row className="align-items-center">
          <Col md={12} xs={12} className="text-center">
            {/* <Image src={CustomImg} alt="Custom Design Jewelry " /> */}
             <div className='player-wrapper'>
                          <video
                            muted
                            autoPlay
                            loop
                            controls={false}
                            playsInline
                            style={{ width: '100%', height: '100%', objectPosition: 'center', objectFit: 'cover', marginBottom: '40px', pointerEvents: 'none'  }}
                          >
                            <source src={CustomVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
          </Col>

          <Col md={12} xs={12}>
            <Heading>
              <span className="text-uppercase">Be the Designer</span>
              <h2 className="text-uppercase">Custom Design  {Je_welryspelling}  </h2>
              <p>
                Indulge in the luxury of self-expression with our custom design {Je_welryspelling}  service. From intricate details to personalized  touches, each piece is crafted to reflect your unique style and story. Elevate your look with bespoke treasures that are asexceptional as you are.
              </p>
            </Heading>

            <div className="text-center">
              <Link to="/custom-design" className="btn outline-base-btn large ">
                Get Started
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CustomDesign;
